<script setup>
import { ref, computed } from 'vue'

import { getI18n } from '@/plugins/i18n'

import { DxPopup } from 'devextreme-vue/popup'

import ServiceAttachmentUpload from '@/components/registry/ServiceAttachmentUpload.vue'

const props = defineProps({
  showDialog: {
    type: Boolean,
    required: true
  },
  formDataSource: {
    type: Object,
    default: () => {}
  },
  isReadonly: {
    type: Boolean,
    default: false
  },
  entitiesId: {
    type: Object,
    default: () => {}
  },
})
const emit = defineEmits(['onSave', 'onCancel'])

const i18n = getI18n()

const serviceAttachmentUploadRef = ref(null)
const onPopupHidden = () => {
  serviceAttachmentUploadRef.value?.resetForm()
  emit('onCancel')
}

const popupToolbar = computed(() => [
  {
    widget: 'dxButton',
    toolbar: 'bottom',
    location: 'after',
    options: {
      text: i18n.t('common.save'),
      onClick: () => { serviceAttachmentUploadRef.value?.uploadFiles() },
    },
  },
  {
    widget: 'dxButton',
    toolbar: 'bottom',
    location: 'after',
    options: {
      text: i18n.t('common.cancel'),
      onClick: () => { serviceAttachmentUploadRef.value?.resetForm(); emit('onCancel') },
    },
  },
])
</script>

<template>
  <div>
    <dx-popup
      v-model:visible="props.showDialog"
      :drag-enabled="true"
      :resize-enabled="true"
      :width="'80rem'"
      height="auto"
      :show-title="true"
      :toolbar-items="popupToolbar"
      @hidden="onPopupHidden"
    >
      <template #content>
        <service-attachment-upload
          ref="serviceAttachmentUploadRef"
          :form-data="props.formDataSource"
          :is-readonly="props.isReadonly"
          :entities-id="props.entitiesId"
          @uploaded="() => emit('onSave')"
        />
      </template>
    </dx-popup>
  </div>
</template>
